module.exports = __webpack_public_path__ + "static/messages_hokej-dd6b027eaabc97f972ab757e1481709f.mp4";